import { render } from "./EventViewsView.vue?vue&type=template&id=6d805446&scoped=true"
import script from "./EventViewsView.vue?vue&type=script&lang=js"
export * from "./EventViewsView.vue?vue&type=script&lang=js"

import "./EventViewsView.vue?vue&type=style&index=0&id=6d805446&scoped=true&lang=css"

import exportComponent from "../../../../../../../name-pronunciation/orator-pro-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d805446"]])

export default __exports__